module.exports = "/assets/data/d8bf776209eb892cad90e07e324bdc85-ME14.data.json";